import React from 'react';
import { Col, Row } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { buildKey } from '@yme/common/index';
import { useWindowSize } from '@yme/hooks/useWindowSize';
export function TestRideContentSkeleton({ currentPerPageValue }) {
    const currentPerPageValueArr = Array(currentPerPageValue).fill('testRideContentSkeletonItem');
    const { isMobileView } = useWindowSize();
    return (React.createElement(Row, null, currentPerPageValueArr.map((item, index) => (React.createElement(Col, { key: buildKey(item, index), lg: 4, md: 6 },
        React.createElement(Skeleton, { skeletonProps: {
                height: 200,
            }, wrapperProps: {
                mbM: 16,
                mbS: 16,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: isMobileView ? 24 : 28,
            }, wrapperProps: {
                width: 200,
                mbM: 24,
                mbS: 16,
            } }))))));
}
